__turbopack_context__.v({
  "button": "Pvz-module-scss-module___BY9jG__button",
  "cityInput": "Pvz-module-scss-module___BY9jG__cityInput",
  "filterPanel": "Pvz-module-scss-module___BY9jG__filterPanel",
  "filterPanel_title": "Pvz-module-scss-module___BY9jG__filterPanel_title",
  "mapWrap": "Pvz-module-scss-module___BY9jG__mapWrap",
  "root": "Pvz-module-scss-module___BY9jG__root",
  "select": "Pvz-module-scss-module___BY9jG__select",
  "shopsList": "Pvz-module-scss-module___BY9jG__shopsList",
});
